import XAPPButton from "app/Core/Components/Button/XAPPButton";
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import React from 'react';
import reducer from '../../Store/Reducers/ComunicadorReducer';
import _ from '@lodash';
import withReducer from 'app/store/withReducer';
import history from 'history.js';
import { connect } from "react-redux";

class CentralNotificacoesNavButton extends XAPPComponent {

    render() {
        const { settings = {}, empresa = null } = this.props;
        const { sistemas = null } = settings;
        return (
            <React.Fragment>
                {!_.isNull(sistemas) && Object.keys(sistemas).length > 0 && !_.isNull(empresa) && !_.isUndefined(sistemas[empresa]) &&
                    <XAPPButton
                        type="Icon"

                        variant="contained"
                        onClick={() => history.push("/" + sistemas[empresa].organizacao + "/" + empresa + "/central-de-notificacoes")}
                        icon={"chat"}
                    />
                }
            </React.Fragment>
        )
    };
}

function mapStateToProps({ fuse, auth }) {
    return {
        footerTheme: fuse.settings.footerTheme,
        settings: auth.user.data.settings,
        user: auth.user.data,
        empresa: fuse.navigation.empresa
    }
}
export default withReducer('Comunicador', reducer)(connect(mapStateToProps)(CentralNotificacoesNavButton));
